export default __webpack_public_path__ + "static/media/img-6.f656759e.png";